import React from "react";
import dayjs from "dayjs";

export const TimelineCellRenderer = ({ data }) => {
    const { seedStartDate, transplantDate, harvestDate, season } = data || {};

    // Skip if any key date is missing or if perennial
    if (!seedStartDate || !transplantDate || !harvestDate || season?.toLowerCase() === "perennial") {
        return null;
    }

    const start = dayjs(seedStartDate, "M/D/YYYY");
    const mid = dayjs(transplantDate, "M/D/YYYY");
    const end = dayjs(harvestDate, "M/D/YYYY");

    const yearStart = dayjs(`${start.year()}-01-01`);
    const yearEnd = dayjs(`${start.year()}-12-31`);
    const totalDays = yearEnd.diff(yearStart, "day");

    const pct = (d) => ((d.diff(yearStart, "day") / totalDays) * 100).toFixed(1);

    const seedPct = pct(start);
    const midPct = pct(mid);
    const endPct = pct(end);

    const firstBarWidth = midPct - seedPct;
    const secondBarWidth = endPct - midPct;

    // Inline styles
    const containerStyle = {
        position: "relative",
        height: "10px",
        width: "100%",
        backgroundColor: "#e0e0e0",
        borderRadius: "0px",
        overflow: "hidden",
    };

    const barBase = {
        position: "absolute",
        height: "100%",
        borderRadius: "0px",
        transition: "all 0.3s ease-in-out", // smooth animation if values change
    };

    const firstBarStyle = {
        ...barBase,
        backgroundColor: "#00b894", // seed→transplant
        left: `${seedPct}%`,
        width: `${firstBarWidth}%`,
    };

    const secondBarStyle = {
        ...barBase,
        backgroundColor: "#0984e3", // transplant→harvest
        left: `${midPct}%`,
        width: `${secondBarWidth}%`,
    };

    const tooltip = `Seed: ${seedStartDate}\nTransplant: ${transplantDate}\nHarvest: ${harvestDate}`;

    return (
        <div style={containerStyle} title={tooltip}>
            <div style={firstBarStyle} />
            <div style={secondBarStyle} />
        </div>
    );
};
